import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../../States/AppContext";

// styles
import {
  AlarmAcknowledgedImg,
  AlarmArrowUpImg,
  AlarmBlue,
  AlarmMessage,
  AlarmRed,
  AlarmWhite,
  AlarmYellow,
} from "./Alarms.elements";

//images + icons
import pauseAlarmIcon from "../../../img/icons/alarm-pause.png";
import alarmCheckUpArrow from "../../../img/icons/alarm-check-up-arrow.png";
import alarmUpArrowOnly from "../../../img/icons/alarm-arrow-only.png";

export const AlarmHr = ({landscape}) => {
  return (
    <>
      <AlarmYellow landscape={landscape}>* HR 140&gt;120</AlarmYellow>
    </>
  );
};

export const AlarmSpo = () => {
  return (
    <>
      <AlarmYellow>**Sp0₂T 85&gt;90</AlarmYellow>
    </>
  );
};

export const AlarmSpoSearching = () => {
  return (
    <>
      <AlarmBlue>Sp0₂T Searching</AlarmBlue>
    </>
  );
};

export const AlarmSt = ({ landscape }) => {
  const { state, setState } = useContext(AppContext);

  return (
    <>
      <AlarmYellow>
        <img
          src={alarmUpArrowOnly}
          style={{
            width: "auto",
            height: "20px",
            marginLeft: "1.2em",
            filter: "invert(100%)",
          }}
        />
        <div> **ST Multi II,aVR</div>
      </AlarmYellow>
    </>
  );
};

export const AlarmStCantAnalyze = () => {
  return (
    <>
      <AlarmBlue>Cannot Analyze ST</AlarmBlue>
    </>
  );
};

export const AlarmVentFib = () => {
  return (
    <>
      <div style={{ position: "relative" }}>
        <AlarmRed>
          <div> *** Vent Fib/Tach</div>
        </AlarmRed>
        <img
          src={alarmCheckUpArrow}
          style={{
            width: "30px",
            height: "auto",
            position: "absolute",
            left: "0",
          }}
        />
      </div>
    </>
  );
};

export const AlarmXTachy = ({ landscape }) => {
  const { state, setState } = useContext(AppContext);

  return (
    <>
      <div style={{ position: "relative" }}>
        <div style={{ position: "absolute", top: ".1em" }}>
         

          {state.acknowledgeAlarms ? (
            <AlarmAcknowledgedImg src={alarmCheckUpArrow} landscape={landscape} />
          ) : (

            <AlarmArrowUpImg src={alarmUpArrowOnly} landscape={landscape} />
          )}


        </div>

        <AlarmRed landscape={landscape}>
          <div>*** xTachy 160&gt;140</div>
        </AlarmRed>
      </div>
    </>
  );
};

export const AlarmQtCantAnalyze = () => {
  return (
    <>
      <AlarmBlue>Cannot Analyze QT</AlarmBlue>
    </>
  );
};

// ALARM PAUSE
export const AlarmPause = ({landscape}) => {
  const [countdown, setCountdown] = useState(120); // Initial countdown value in seconds

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, []);

  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;

  return (
    <>
      <AlarmWhite landscape={landscape} >
        {/* <img src={pauseAlarmIcon} style={{ width: "20px" }} /> */}
        <img src={pauseAlarmIcon}  />

        <div>Alarms Paused</div>
        <div>{`${minutes.toString().padStart(2, "0")}:${seconds
          .toString()
          .padStart(2, "0")}`}</div>
      </AlarmWhite>
      {/* countdown from 2 min */}
    </>
  );
};
